import React, { useState } from "react";
import { graphql } from "gatsby";
import { Container, Grid, Modal, withStyles, Button } from "@material-ui/core";
import Done from "@material-ui/icons/Done";
import CloseIcon from "@material-ui/icons/Close";
import css from "./pricing.module.css";
import Contact from "components/contact";
import Customers from "components/customers";
import Faq from "components/faq";
import Layout from "components/layout";
import SEO from "components/seo";
import Close from "@material-ui/icons/Close";
import { scheduleDiscoveryCall } from "../utils/calendly";

const DoneIcon = withStyles({
  root: {
    color: "#29A176",
    fontSize: 16,
    verticalAlign: "middle",
  },
})(Done);

const CrossIcon = withStyles({
  root: {
    color: "#BAC8D7",
    fontSize: 16,
    verticalAlign: "middle",
  },
})(Close);

const Data = ({ value }) => {
  return value === "yes" ? (
    <DoneIcon />
  ) : value === "no" ? (
    <CrossIcon />
  ) : (
    value
  );
};

const NewOcrCards = ({ plans_summary }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const closeModal = () => {
    setIsDialogOpen(false);
  };

  return (
    <div>
      <Grid container spacing={2} justify="center">
        <Grid item xs={12} sm={6} md={4}>
          <div className={css.plan_card}>
            <div className={css.indicator} style={{ background: "#E5E9FF" }} />

            <div className={css.plan_card_top}>
              <div className={css.plan_name}>Starter</div>
              <div className={css.plan_text2} style={{ marginTop: 12 }}>
                For individuals or those looking to try out the platform
              </div>

              <div style={{ marginTop: 24 }}>
                <Button
                  color="primary"
                  fullWidth
                  variant="outlined"
                  href="https://app.nanonets.com/"
                >
                  Sign Up For Free
                </Button>
              </div>

              <p>
                <span className={css.amount}>$0</span>
              </p>

              <div className={css.plan_text2} style={{ marginTop: 12 }}>
                Free forever
              </div>
            </div>

            <div style={{ margin: "16px 0", borderTop: "1px solid #e0e3e8" }} />

            <div className={css.features}>
              <ul>
                {plans_summary[0].rows.map((row, index) => (
                  <li key={index}>
                    <DoneIcon />
                    <span className={css.feature_name}>{row.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <div className={css.plan_card}>
            <div className={css.indicator} style={{ background: "#98A9FF" }} />

            <div className={css.plan_card_top}>
              <div className={css.plan_name}>Pro</div>
              <div className={css.plan_text2} style={{ marginTop: 12 }}>
                For teams seeking advanced tools and workflow setups for their
                growing business
              </div>

              <div style={{ marginTop: 24 }}>
                <Button
                  color="primary"
                  fullWidth
                  variant="contained"
                  href="https://app.nanonets.com/#/models"
                >
                  free trial for 7 days
                </Button>
              </div>

              <p>
                <span className={css.amount}>$0.1</span>
                <span style={{ fontSize: 12 }}>/page</span>
              </p>

              <div className={css.plan_text2} style={{ marginTop: 12 }}>
                Starts at $499/model monthly
              </div>
            </div>

            <div style={{ margin: "16px 0", borderTop: "1px solid #e0e3e8" }} />

            <div className={css.features}>
              <ul>
                {plans_summary[1].rows.map((row, index) => (
                  <li key={index}>
                    <DoneIcon />
                    <span className={css.feature_name}>{row.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <div className={css.plan_card}>
            <div className={css.indicator} style={{ background: "#546fff" }} />

            <div className={css.plan_card_top}>
              <div className={css.plan_name}>Enterprise</div>
              <div className={css.plan_text2} style={{ marginTop: 12 }}>
                For organizations that need additional security and control to
                process data at scale
              </div>

              <div style={{ marginTop: 24 }}>
                <Button
                  color="primary"
                  fullWidth
                  variant="contained"
                  href="#contact"
                >
                  Contact Sales
                </Button>
              </div>

              <div className={css.plan_text2} style={{ marginTop: 12 }}>
                Talk to us to get an estimate and specify custom requirements
                for your business.
              </div>
            </div>

            <div style={{ margin: "16px 0", borderTop: "1px solid #e0e3e8" }} />

            <div className={css.features}>
              <ul>
                <li style={{ color: "#354454", fontSize: 14 }}>
                  <b>Everything in Pro, and:</b>
                </li>
                {plans_summary[2].rows.map((row, index) => (
                  <li key={index}>
                    <DoneIcon />
                    <span className={css.feature_name}>{row.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Grid>
      </Grid>

      <Modal
        style={{ display: "flex" }}
        open={isDialogOpen}
        onClose={closeModal}
      >
        <div
          style={{
            maxWidth: 480,
            margin: "auto",
            padding: 40,
            borderRadius: 4,
            background: "#fff",
            overflow: "auto",
            outline: 0,
            position: "relative",
          }}
        >
          <div>
            <p style={{ color: "#354454", fontSize: 16, fontWeight: 600 }}>
              How number of pages is calculated?
            </p>
            <p style={{ color: "#94A1AF", fontSize: 14, fontWeight: 600 }}>
              Included Pages
            </p>
            <p style={{ color: "#354454", fontSize: 12 }}>
              Number of Pages is calculated based on the number of fields in the
              model.
            </p>
            <p style={{ color: "#354454", fontSize: 12 }}>
              If there are 5 fields, The number of pages is 50,000/5 = 10,000.
              <br />
              If there are 10 fields, The number of pages is 50,000/10 = 5,000.
            </p>
            <p style={{ color: "#94A1AF", fontSize: 14, fontWeight: 600 }}>
              Cost of Additional Pages
            </p>
            <p style={{ color: "#354454", fontSize: 12 }}>
              The Total Number of Pages multiplied by the Number of Fields in
              the model is set to a 50,000. After that charges apply at
              $0.01/field/page. For 10 fields the cost is $0.1/Additional Page,
              for 5 fields it would be $0.05/Additional Page
            </p>
          </div>

          <div className={css.closeIcon} onClick={closeModal}>
            <CloseIcon color="inherit" fontSize="inherit" />
          </div>
        </div>
      </Modal>
    </div>
  );
};

const Pricing = ({ data }) => {
  const pageData = data.markdownRemark.frontmatter.data;
  let features = pageData.plans_comparison;

  return (
    <Layout>
      <SEO title={pageData.seoTitle} description={pageData.seoDescription} />

      <div style={{ marginTop: 72 }} />

      <div style={{ textAlign: "center" }}>
        <p
          style={{
            color: "#23325F",
            fontSize: 32,
            fontWeight: 500,
            margin: 0,
            textAlign: "center",
          }}
        >
          Simple and Transparent Pricing
        </p>

        <p
          style={{
            color: "#66788c",
            fontSize: 16,
          }}
        >
          No hidden charges. Change plan or cancel anytime.
        </p>
      </div>

      <div style={{ marginTop: 72 }} />

      <Container>
        <div
          style={{
            margin: -16,
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <div style={{ padding: 16, flex: "2 2 800px" }}>
            <NewOcrCards plans_summary={pageData.plans_summary} />
          </div>
        </div>
      </Container>

      <div style={{ marginTop: 100 }} />

      <Container>
        <div
          style={{
            textAlign: "center",
            minHeight: 240,
            background:
              "url(/media/pricing-image-1.svg) no-repeat center center",
            backgroundSize: "cover",
            padding: 40,
            color: "#fff",
            borderRadius: 8,
          }}
        >
          <div style={{ fontSize: 24, fontWeight: 600 }}>
            Have a unique use-case you'd like to discuss?
          </div>

          <p style={{ fontSize: 16 }}>
            We&apos;re happy to help you find out what your organisation needs
          </p>

          <div style={{ marginTop: 32 }}>
            <Button
              color="primary"
              size="large"
              onClick={scheduleDiscoveryCall}
              style={{ background: "#fff", paddingLeft: 24, paddingRight: 24 }}
            >
              Talk to us
            </Button>
          </div>
        </div>
      </Container>

      <div style={{ marginTop: 144 }} />

      <p
        style={{
          color: "#23325F",
          fontSize: 32,
          fontWeight: 600,
          textAlign: "center",
        }}
      >
        Compare all plans
      </p>

      <div style={{ marginTop: 72 }} />

      <Container>
        <div style={{ overflow: "auto", maxWidth: "100%", paddingTop: 16 }}>
          <table className={css.table}>
            <thead>
              <tr>
                <td></td>
                <td className={css.table_header}>
                  <div
                    className={css.indicator}
                    style={{ background: "#E5E9FF" }}
                  />
                  Starter
                </td>
                <td className={css.table_header}>
                  <div
                    className={css.indicator}
                    style={{ background: "#98A9FF" }}
                  />
                  Pro
                </td>
                <td className={css.table_header}>
                  <div
                    className={css.indicator}
                    style={{ background: "#546FFF" }}
                  />
                  Enterprise
                </td>
              </tr>
            </thead>
            <tbody>
              {features.map((feature) => (
                <tr key={feature.name}>
                  <td>{feature.name}</td>
                  <td>
                    <Data value={feature.starter} />
                  </td>
                  <td>
                    <Data value={feature.pro} />
                  </td>
                  <td>
                    <Data value={feature.enterprise} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Container>

      <div style={{ marginTop: 100 }} />

      <Container>
        <Faq faq={pageData.faq} />
      </Container>

      <div style={{ marginTop: 160 }} />

      <Container>
        <Customers />
      </Container>

      <div id="contact" />
      <div style={{ marginTop: 320 }} />

      <Contact />
    </Layout>
  );
};

export default Pricing;

export const query = graphql`
  query {
    markdownRemark(frontmatter: { page: { eq: "pricing" } }) {
      frontmatter {
        data {
          seoTitle
          seoDescription
          page_title
          plans_summary {
            plan_name
            rows {
              text
            }
          }
          plans_comparison {
            name
            starter
            pro
            enterprise
          }
          faq {
            question
            answer
          }
        }
      }
    }
  }
`;
